import { render } from "./StartGameButton.vue?vue&type=template&id=1079b371&scoped=true"
import script from "./StartGameButton.vue?vue&type=script&lang=js"
export * from "./StartGameButton.vue?vue&type=script&lang=js"

import "./StartGameButton.vue?vue&type=style&index=0&id=1079b371&scoped=true&lang=css"

import exportComponent from "/Users/corentin/Documents/Projets/Wordle/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1079b371"]])

export default __exports__